
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: 'login',
components: {
XInput,
XButton
},
props: {
loginTitle: '',
isBtnLoading: false
},
data () {
return {
loginForm: {
username: '',
password: '',
captcha: '',
uuid: ''
},
userToken: '',
account: '',
captchaUrl: ''
}
},
mounted () {
this.accountInfo = JSON.parse(localStorage.getItem('accountInfo'))
if (this.accountInfo) {
this.loginForm.username = this.accountInfo.account
this.loginForm.password = this.accountInfo.password
}
this.getCaptcha()
},
methods: {

submitLogin () {
this.$emit('userInfo', this.loginForm)
this.$parent.submitLogin()
},
getCaptcha () {
this.$api.get('/login/captchaPicture', null,
r => {
this.captchaUrl = r.data.captchaPicture
this.loginForm.uuid = r.data.uuid
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
refreshCaptcha () {
this.getCaptcha()
}
}
}



// WEBPACK FOOTER //
// ./src/components/loginCaptcha.vue